import { useCallback, useEffect, useState } from 'react';

export function useRemoteData(loader, dependencies = [], enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState('');

  const reload = useCallback(async () => {
    if (!enabled) {
      setLoading(false);
      setError('');
      return null;
    }

    setLoading(true);
    setError('');
    try {
      const next = await loader();
      setData(next);
      return next;
    } catch (err) {
      setError(err.message || 'Falha ao carregar dados.');
      return null;
    } finally {
      setLoading(false);
    }
  }, [enabled, ...dependencies]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      setError('');
      return;
    }

    reload();
  }, [enabled, reload]);

  return { data, loading, error, reload, setData };
}
